import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { Typography } from '../../../style/styled';
import t from './theme';
var SubtitleCoreStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n\n    color: ", ";\n"])), t.getSubtitleTextColor);
var Subtitle = styled(Typography)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    font-size: 16px;\n"])), SubtitleCoreStyle);
export default {
  Subtitle: Subtitle
};